import { Component, ViewEncapsulation, Renderer2, ChangeDetectorRef, NgZone, Output, EventEmitter } from '@angular/core';
import { DispatchesService } from '../../shared/services/dispatches.service';
import { GlobalsService } from '../../shared/services/globals.service';
import { Subscription, fromEvent } from 'rxjs';
import { DataStateChangeEvent, RowClassArgs } from '@progress/kendo-angular-grid';
import { v_DispatchLaborBus } from '../../shared/models/v_DispatchLaborBus';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { DispatchLaborBus } from '@app/cp/shared/models/DispatchLaborBus';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { aggregateBy } from '@progress/kendo-data-query';
import { MSCLFilterClass } from '@app/cp/shared/classes/filters/MSCLFilterClass';
import { tap } from 'rxjs/internal/operators/tap';
import { take } from 'rxjs/operators';
import * as _ from 'lodash';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';

@UseFeatureFlagSet()
@Component({
  selector: 'dispatch-labor',
  templateUrl: './dispatch-labor.component.html',
  styleUrls: ['./dispatch-labor.component.scss'],
    encapsulation: ViewEncapsulation.None,
    styles: ['.k-grid tr.dragging {background-color: #f45c42;}']
})
export class DispatchLaborComponent extends BaseGridEditLineComponent<v_DispatchLaborBus, null, DispatchesService>  {
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    timeTypeCF: MSCLFilterClass;
    laborTypeCF: MSCLFilterClass;
    resourceNameCF: MSCLFilterClass;
    maxEndDate: Date;
    minEndDate: Date;
    private currentSubscription: Subscription;
    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: DispatchesService, private zone: NgZone, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;
        this.disableCpSearchDialog();
        this.className = "v_DispatchLaborBus";
        this.appCode = "DispatchLabor";
        this.appName = "Dispatch Labor";
        this.aggregates = [{ field: 'hoursWorked', aggregate: 'sum' }];
        this.state.group = [{ field: 'hoursWorked', aggregates: this.aggregates }];
    }
    @Output() dropEvent: EventEmitter<any> = new EventEmitter<any>();

    createForm() {
        this.editForm = new UntypedFormGroup({
            'dispatchLaborId': new UntypedFormControl(),
            'dispatchId': new UntypedFormControl(),
            'hoursWorked': new UntypedFormControl(),
            'personId': new UntypedFormControl('', Validators.required),
            'laborTypeId': new UntypedFormControl('', Validators.required),
            'timeTypeId': new UntypedFormControl('', Validators.required),
            'isHelper': new UntypedFormControl(),
            'nonPaid': new UntypedFormControl(),
            'startDate': new UntypedFormControl(),
            'endDate': new UntypedFormControl(),
            'useLocationRate': new UntypedFormControl(),
            'mgrApproved': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'timeTypeName': new UntypedFormControl(),
            'laborTypeName': new UntypedFormControl(),
            'inFinance': new UntypedFormControl()
        });

    }
    setForm() {
        this.editForm.patchValue({
            dispatchLaborId: this.selectedData.dispatchLaborId,
            dispatchId: this.selectedData.dispatchId,
            hoursWorked: this.selectedData.hoursWorked,
            personId: this.selectedData.personId,
            laborTypeId: this.selectedData.laborTypeId,
            timeTypeId: this.selectedData.timeTypeId,
            isHelper: this.selectedData.isHelper,
            nonPaid: this.selectedData.nonPaid,
            startDate: this.selectedData.startDate,
            endDate: this.selectedData.endDate,
            useLocationRate: this.selectedData.useLocationRate,
            mgrApproved: this.selectedData.mgrApproved,
            insertUserId: this.selectedData.insertUserId,
            insertDt: this.selectedData.insertDt,
            updateUserId: this.selectedData.updateUserId,
            updateDt: this.selectedData.updateDt,
            timeTypeName: this.selectedData.timeTypeName,
            laborTypeName: this.selectedData.laborTypeName,
            inFinance: this.selectedData.inFinance
        });
        this.minEndDate = this.selectedData.startDate;
        this.maxEndDate = DateFunctions.addDays(this.selectedData.startDate, 1);
        this.validateDispatchLaborOverLap();
    }
    customCanSaveForm() {
        var startDate = this.editForm.value.startDate;
        var endDate = this.editForm.value.endDate;
        if (startDate < endDate) {
            var endTestDate = DateFunctions.addDays(startDate, 1);
            if (endDate <= endTestDate) {
                if (this.overlap) {
                    return false;
                }
                return true;
            }
        }
        return false;
    }
    hasRowEditRights(dataItem: v_DispatchLaborBus): boolean {

        return dataItem.inFinance ? this.rights.FinancialLockOverride : true;
    }
    getChangedObject(data: v_DispatchLaborBus) {
        let busObj: DispatchLaborBus = new DispatchLaborBus(data);
        busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        busObj.setParentId(this._parentId);
        busObj.setBeforeSave();
        return busObj;
    }
    protected save(data: v_DispatchLaborBus) {
        let busObj: DispatchLaborBus = this.getChangedObject(data);
        this.svc_data.saveLabor(busObj).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                let dataObj: v_DispatchLaborBus = new v_DispatchLaborBus(info.primaryReturnView);
                this.saveSuccess(dataObj);
            }
            else {
                this.saveError(info.primaryReturn, info.message);
            }
        });
    }
    deleteIndividual(data: v_DispatchLaborBus) {
        if (data.hasId) {
            this.svc_data.deleteLabor(data.dispatchLaborId).subscribe((dataObj: BaseMessageInfo) => {
                if (!dataObj.saveError) {
                    this.deleteSuccess(data);
                    this.removeLocal(data);
                }
                else {
                    this.deleteError(data, dataObj.message);
                }
            });
        }
        else {
            this.closeEditor();
        }
    }
    public onChangeStartDate(value: Date): void {
        this.minEndDate = new Date(value);
        this.maxEndDate =  DateFunctions.addDays(this.minEndDate, 1);
        if (!this.editForm.value["endDate"]) {
            this.editForm.patchValue({
                endDate: this.minEndDate
            });

        }
        else{
            this.validateDispatchLaborOverLap();
        }
        this.editForm.updateValueAndValidity();
    }
    setFromReferenceData(data: v_DispatchLaborBus) {
        data.fullName = this.personName(data.personId);
        data.laborTypeName = this.referenceData.getLaborTypes(data.laborTypeId);
        data.timeTypeName = this.referenceData.getTimeTypes(data.timeTypeId);
        return data;
    }
    processGridData() {
        if (CommonFunctions.hasArrayElementValue(this.gridData)) {
            this.aggregateResults = aggregateBy(this.gridData, this.aggregates);
        }
        this.laborTypeCF = new MSCLFilterClass('laborTypeName', 'laborTypeName', this.gridData);
        this.timeTypeCF = new MSCLFilterClass('timeTypeName', 'timeTypeName', this.gridData);
        this.resourceNameCF = new MSCLFilterClass('fullName', 'fullName', this.gridData);
        if (this.currentSubscription) { this.currentSubscription.unsubscribe(); }
        if (this.canDrag) {
            this.zone.onStable.pipe(take(1))
                .subscribe(() => this.currentSubscription = this.handleDragAndDrop());
        }

    }
    customCheckBoxChanged(e: any, dataItem, rowIndex, column, columnIndex) {
        if (column.field === "mgrApproved") {
            this.editForm.patchValue({
                mgrApproved: e.target.checked
            });

        }
        if (column.field === "isHelper") {
            this.editForm.patchValue({
                isHelper: e.target.checked
            });

        }
        if (column.field === "nonPaid") {
            this.editForm.patchValue({
                nonPaid: e.target.checked
            });

        }
        if (column.field === "useLocationRate") {
            this.editForm.patchValue({
                useLocationRate: e.target.checked
            });

        }

    }
    rowClassFunction(context: RowClassArgs) {
        if (context.dataItem.inFinance) {
            return { inFinance: true }
        }
    }
    overlap = null;
    afterSaveCurrent()
    { this.overlap = null; }
    private async validateDispatchLaborOverLap(): Promise<boolean> {

        if (this.compFeatureFlagSet.featureFlagSet['prevent-duplicate-time-entries-from-being-entered']) {
            if (this.editForm.value.personId && this.editForm.value.endDate && this.editForm.value.startDate) {
                //var startDate = DateFunctions.getDateTimeWithUTCOffset(this.editForm.value.startDate);
                //var endDate = DateFunctions.getDateTimeWithUTCOffset(this.editForm.value.endDate);
                var startDate = this.editForm.value.startDate;
                var endDate = this.editForm.value.endDate;
                var personId = this.editForm.value.personId;
                var dispatchLaborId = "";
                if (this.editForm && this.editForm.value && this.editForm.value.dispatchLaborId) {
                    dispatchLaborId = this.editForm.value.dispatchLaborId;
                }

                var overlap = this.gridData.filter(a => a.personId == personId
                    && a.dispatchLaborId != dispatchLaborId
                    && ((a.startDate > startDate && a.startDate < endDate)
                        || (a.endDate > startDate && a.endDate < endDate)
                        || (a.startDate <= startDate && endDate <= a.endDate))
                )

                if (overlap.length) {
                    this.overlap = {
                        startDate: overlap[0].startDate,
                        endDate: overlap[0].endDate,
                        dispatchNumber: "Current"
                    }
                    return false;
                }
                this.overlap = null;
                var changed = this.gridData.filter(a => a.isUpdated).map(a => a.dispatchLaborId);
                if (this.editForm && this.editForm.value && this.editForm.value.dispatchLaborId) {
                    changed.push(this.editForm.value.dispatchLaborId);
                }
                var busObj =
                {
                    startDate: DateFunctions.getDateTimeWithUTCOffset(this.editForm.value.startDate),
                    endDate: DateFunctions.getDateTimeWithUTCOffset(this.editForm.value.endDate),
                    personId: this.editForm.value.personId,
                    dispatchLaborIdsToSkip: changed
                }

                await this.svc_data.validateDispatchLaborOverLap(busObj).toPromise().then((data: any) => {
                    if (data.laborOverlap) {
                        this.overlap = {
                            startDate: data.overlaps[0].startDate,
                            endDate: data.overlaps[0].endDate,
                            dispatchNumber: data.overlaps[0].dispatchNumber
                        }
                    }
                    else {
                        this.overlap = null;
                    }
                })

            }
            if (this.overlap) {
                return false;
            }
        } else { this.overlap = null; }
        return true;
    }
    canEditRow(dataItem: v_DispatchLaborBus) {
        return (!dataItem.inFinance && !dataItem.mgrApproved) || this.rights.FinancialLockOverride &&
       (!dataItem.mgrApproved || this.rights.editDeleteApprovedDispatchLabor);
    }
    canDelete(dataItem: v_DispatchLaborBus): boolean {
        return (!dataItem.inFinance && !dataItem.mgrApproved) || this.rights.FinancialLockOverride || (dataItem.mgrApproved && !dataItem.inFinance && this.rights.editDeleteApprovedDispatchLabor);
    }
    tableRow = node => node.tagName.toLowerCase() === 'tr';
    closest = (node, predicate) => {
        while (node && !predicate(node)) {
            node = node.parentNode;
        }

        return node;
    };
    private handleDragAndDrop(): Subscription {
        if (!this.canDrag) {
            return;
        }
        const sub = new Subscription(() => { });
        let draggedItemIndex;
        const tableRows = Array.from(document.querySelectorAll('div.laborGridDiv > .k-grid tr'));
        const _this = this;
        tableRows.forEach(item => {
            this.renderer.setAttribute(item, 'draggable', 'true');
            const dragStart = fromEvent<DragEvent>(item, 'dragstart');
            const dragOver = fromEvent(item, 'dragover');
            const dragEnd = fromEvent(item, 'dragend');
            var dropItemIndex;
            var dataItem;
            sub.add(dragStart.pipe(
                tap(({ dataTransfer }) => {
                    try {

                        //const dragImgEl = document.createElement('span');
                        //dragImgEl.setAttribute('style', 'position: absolute; display: block; top: 0; left: 0; width: 0; height: 0;');
                        //document.body.appendChild(dragImgEl);
                        //dataTransfer.setDragImage(dragImgEl, 0, 0);
                    } catch (err) {
                        // IE doesn't support setDragImage
                    }
                    try {
                        // Firefox won't drag without setting data
                        dataTransfer.setData('application/json', "");
                    } catch (err) {
                        // IE doesn't support MIME types in setData
                    }
                })
            ).subscribe(({ target }) => {
                const row: HTMLTableRowElement = <HTMLTableRowElement>target;
                draggedItemIndex = row.rowIndex;
                var data = _.cloneDeep(this.grid.data);
                dataItem = data.data[draggedItemIndex];
             //   dataItem.dragging = true;
            }));

            //sub.add(dragOver.subscribe((e: any) => {
            //    e.preventDefault();
            //    const dataItem = this.gridData.data.splice(draggedItemIndex, 1)[0];
            //    const dropIndex = closest(e.target, tableRow).rowIndex;
            //    const dropItem = this.gridData.data[dropIndex];

            //    draggedItemIndex = dropIndex;
            //    this.zone.run(() =>
            //       // this.gridData.data.splice(dropIndex, 0, dataItem)
            //    );
            //}));

            sub.add(dragEnd.subscribe((e: any) => {
                e.preventDefault();
                var event = _.cloneDeep(dataItem);
                event.dropid = event.dispatchLaborId

                event.detailType = 1;
                this.dropEvent.emit(event);
               // const dataItem = this.gridData.data[draggedItemIndex];
             //   dataItem.dragging = false;
            }));
        });

        return sub;
    }
    public dataStateChange(state: DataStateChangeEvent): void {
        console.log("dataStateChange: ", state,this.currentSubscription, this);
        super.dataStateChange(state);
        if (this.canDrag) {
            this.currentSubscription.unsubscribe();
            this.zone.onStable.pipe(take(1))
                .subscribe(() => this.currentSubscription = this.handleDragAndDrop());
        }
        //if (!this.canDrag) {
        //    super.dataStateChange(state);
        //}
        //else {
        //    this.currentSubscription.unsubscribe();
        //    this.zone.onStable.pipe(take(1))
        //        .subscribe(() => this.currentSubscription = this.handleDragAndDrop());
        //}

    }
}
